/**
 * Separator for composite lookup keys.
 *
 * Several places key a Map by more than one field — (refdes, pin), or
 * (part, value, footprint). Joining those with an ordinary character invites
 * collisions, because a footprint or a pin name may contain it: "U1" pin "0A"
 * and "U10" pin "A" must not land on the same key. ASCII Unit Separator was
 * defined for exactly this and cannot appear in CIRCAD data.
 *
 * It is built by code point rather than written out. Putting the character
 * itself in the source leaves a control byte there, which makes git and grep
 * treat the whole file as binary — the keys still work, but the file stops
 * being readable by the tools used on it every day.
 *
 * These keys live in memory only. Nothing written to disk depends on them.
 */
export const KEY_SEP = String.fromCharCode(31);
